import React from 'react';
import styled from '@emotion/styled'
import { containers, Grid, TextEnterExit } from 'style';
import { css } from '@emotion/core'
import { DataStoreService } from 'utils';
import { Markdown } from '..';
import Emitter from '../../utils/emitter';
import GA from '../../utils/ga'

class TextWithFiltersComponent extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      services: null,
      service: ''
    };

    this.setServiceFilter = this.setServiceFilter.bind(this);
    this.setService = this.setService.bind(this);
  }
  componentWillUnmount(){ 
    if (Emitter){
      Emitter.removeListener('filterByService', this.setService);
    }
  }
  componentDidMount() {
    Emitter.on('filterByService', this.setService); 

    this.setState(() => ({
      services: DataStoreService.getServices(),
    }));
  }
  setServiceFilter(service){
    Emitter.emit('filterByService', service); 
    GA.serviceFilter(service);
  }
  setService(service){
    this.setState({service: service === this.state.service ? '' : service})
  }
  render() {
    const {services} = this.state
    const {text} = this.props
    return(
      <Grid.Wrapper id="TextWithFiltersComponent">
        <div className="wrapper">
        <div className="container-fluid">
          <div className="row">
            <div className="col-xs-12 col-md-10">
              <Text>
                <Markdown
                  source={text}
                />
              </Text>
            </div>
            <div className="col-xs-12 col-md-2">
              {services && <div css={service_css} className={`dot-link ${this.state.service === '' ? 'active' : ''}`} onClick={()=>this.setServiceFilter('')}>All</div>}
              {services && services.map(service => <div css={service_css} className={`dot-link ${service === this.state.service ? 'active' : ''}`} onClick={()=>this.setServiceFilter(service)} key={service}>{service}</div>)}
            </div>
          </div>
          </div>
        </div>
      </Grid.Wrapper>
    )
  };
}

const Text = styled.div`

    ${TextEnterExit};
    
    margin: 0 auto;

    font-family: 'TomoSlab';
    font-weight: 100;

    * {
      font-weight: 100;
    }
`;

const service_css = css`
  display: block;

  @media only screen and (max-width: 800px){
    &:first-child{
      margin-top: 2rem;
    }
  }
`;

export default TextWithFiltersComponent;
